/// <amd-module name="VSS/Diagnostics/UI/Components/Diagnostics/Diagnostics" />
import * as React from "react";

import { IDiagnosticDataService } from "VSS/Diagnostics/DiagnosticDataService";
import { Components, IVssComponentContext, VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { IDiagnosticData } from "VSS/Platform/Page";

interface IDiagnosticsState {
    compiledDiagnosticData: IDiagnosticData;
    diagnosticData: IDiagnosticData;
    showDiagnosticsDialog: boolean;
}

class Diagnostics extends VssComponent<{}, IDiagnosticsState> {
    constructor(props: {}, context: IVssComponentContext) {
        super(props);

        const diagnosticDataService = context.pageContext.getService<IDiagnosticDataService>("IDiagnosticDataService");
        this.state = {
            diagnosticData: diagnosticDataService.getDiagnosticData(),
            compiledDiagnosticData: diagnosticDataService.getCompiledDiagnosticData(),
            showDiagnosticsDialog: false
        };
    }

    public render(): JSX.Element {
        return (
            <React.Fragment>
                {this.state.diagnosticData.contributions && (
                    <span key="diagnostics-section" className="perf-section warning actionable" onClick={this.showDiagnosticsDialog}>
                        Diagnostics...
                    </span>
                )}
                {this.state.showDiagnosticsDialog && (
                    <WrappedComponent
                        dependencies={["ms.vss-features.diag-dialog-content"]}
                        wrappedType="vss.perf-diagnostics-dialog"
                        onDismiss={this.hideDiagnosticsDialog}
                        diagnostics={this.state.diagnosticData}
                        compiledDiagnostics={this.state.compiledDiagnosticData}
                    />
                )}
            </React.Fragment>
        );
    }

    private hideDiagnosticsDialog = () => {
        this.setState({ showDiagnosticsDialog: false });
    };

    private showDiagnosticsDialog = () => {
        this.setState({ showDiagnosticsDialog: true });
    };
}

Components.add("perfbar.diagnoticsSection", Diagnostics);
